import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type IndexUserRagResponse = {
  chunksWritten: number;
  skipped: number;
};

export function indexUserRagErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err) {
    const message = String((err as { message: string }).message);
    if (message && !message.startsWith('Firebase')) {
      return message;
    }
  }
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/failed-precondition') {
      return 'Search indexing is not configured. Contact support if this persists.';
    }
    if (code === 'functions/unauthenticated') {
      return 'Sign in to re-index your data.';
    }
    if (code === 'functions/unavailable') {
      return 'Indexing service is temporarily unavailable. Try again.';
    }
    if (code === 'functions/internal' || code === 'functions/deadline-exceeded') {
      return 'Indexing failed. Try again in a moment.';
    }
  }
  return err instanceof Error ? err.message : 'Indexing failed.';
}

export async function indexUserRag(): Promise<IndexUserRagResponse> {
  const fn = httpsCallable<void, IndexUserRagResponse>(functions, 'indexUserRag');
  const result = await fn();
  const chunksWritten =
    typeof result.data.chunksWritten === 'number' && Number.isFinite(result.data.chunksWritten)
      ? Math.max(0, Math.floor(result.data.chunksWritten))
      : 0;
  const skipped =
    typeof result.data.skipped === 'number' && Number.isFinite(result.data.skipped)
      ? Math.max(0, Math.floor(result.data.skipped))
      : 0;
  return { chunksWritten, skipped };
}
